export class AnimateStyleBlocks {
  constructor() {
    this.styleBlocksElements = document.querySelectorAll(`.js-style-item`);

    this.HEAD_HEIGTH = 95;
    this.ELEMENT_PADDING = 13;

    this._onElementMouseEnter = this._onElementMouseEnter.bind(this);
    this._onElementMouseLeave = this._onElementMouseLeave.bind(this);
    this._onElementFocus = this._onElementFocus.bind(this);
    this._onElementBlur = this._onElementBlur.bind(this);
  }

  _getElementHeight(element) {
    return element.getBoundingClientRect().height;
  }

  _setElementHeight(element) {
    element.style.height = `fit-content`;
  }

  _setModalElementTopPosition(target) {
    const modalElement = target.querySelector(`.js-style-modal`);
    const textElement = target.querySelector(`.js-style-text`);

    modalElement.style.top = `calc(100% - ${this.HEAD_HEIGTH + this.ELEMENT_PADDING + this._getElementHeight(textElement)}px)`;
  }

  _resetModalElementTopPosition(target) {
    const modalElement = target.querySelector(`.js-style-modal`);
    modalElement.style.top = ``;
  }

  _addElementJsInitClass(element) {
    element.classList.add(`style__list-link--js-init`);
  }

  _onElementBlur(evt) {
    this._resetModalElementTopPosition(evt.currentTarget);
  }

  _onElementFocus(evt) {
    this._setModalElementTopPosition(evt.currentTarget);
  }

  _onElementMouseLeave(evt) {
    this._resetModalElementTopPosition(evt.currentTarget);
  }

  _onElementMouseEnter(evt) {
    this._setModalElementTopPosition(evt.currentTarget);
  }

  init() {
    if (this.styleBlocksElements.length) {
      this.styleBlocksElements.forEach((styleBlockElement) => {
        const modalElement = styleBlockElement.querySelector(`.js-style-modal`);

        this._addElementJsInitClass(styleBlockElement);
        this._setElementHeight(modalElement);

        styleBlockElement.addEventListener(`mouseenter`, this._onElementMouseEnter);
        styleBlockElement.addEventListener(`mouseleave`, this._onElementMouseLeave);
        styleBlockElement.addEventListener(`focus`, this._onElementFocus);
        styleBlockElement.addEventListener(`blur`, this._onElementBlur);
      });
    }
  }
}
